import { render, staticRenderFns } from "./serviceOrderInfo.vue?vue&type=template&id=51a1edc6&scoped=true"
import script from "./serviceOrderInfo.vue?vue&type=script&lang=js"
export * from "./serviceOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./serviceOrderInfo.vue?vue&type=style&index=0&id=51a1edc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a1edc6",
  null
  
)

export default component.exports